import React from "react";
import MOTKGAMETITLE from '../Assets/Images/Title.png';
import logo from '../Assets/Images/ObesquitoLogo.png';
import DropDownMenu from '../Component/Menudropdown';
function MOTKPAGE(){
    return(
        <div className="MOTK">
        <div style={{width: '100%', height:'50px',display:'flex'}} className="menuBar">
            <div>
                <img src={logo} className='background-Image'/>
            </div>
            <div>
                <DropDownMenu>

                </DropDownMenu>
            </div>
        </div>
        <div style={{width: '100%'}}>
            <div className="section-Border">
                <div style={{height:'500px'}}>
                <img src={MOTKGAMETITLE} className='background-Image' alt='MOTK Game Title' style={{height:'500px',aspectRatio:  5/1}}/>
                </div>
            </div>
            <div className="section-Border">
                <div>
                    <h1 style={{textAlign:"right"}}>
                        selling point 1
                    </h1>
                    <p  style={{textAlign:"right"}}>
                        yo
                    </p>
                </div>
                <div>
                    <h1 style={{textAlign:"left"}}>
                        selling point 2
                    </h1>
                    <p style={{textAlign:"left"}}>
                        yo2
                    </p>
                </div>
                <div>
                    <h1 style={{textAlign:"right"}}>
                        selling point 3
                    </h1>
                    <p  style={{textAlign:"right"}}>
                        yo3
                    </p>
                </div>


            </div>
            </div>
        </div>
    )
}

export default MOTKPAGE